import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

describe('Index NewPatient', () => {
  describe('Start', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise);
      
      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();


      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull();
    });    
  }); 
  
  describe('Next Start To Gender Page', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('男性')).toBeInTheDocument();
      expect(screen.getByText('女性')).toBeInTheDocument();
      expect(screen.queryByText('再来男性')).toBeNull();
      expect(screen.queryByText('再来女性')).toBeNull();

      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();
      
    });
  });  

  describe('Back Gender To Start Page', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('男性')).toBeInTheDocument();
      expect(screen.getByText('女性')).toBeInTheDocument();

      expect(screen.getByText('戻る')).toBeInTheDocument();

      const backButton = screen.getByText('戻る')
      fireEvent.click(backButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();


      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull();

    });
  });

  describe('Gender To Confirmation Page', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);
      const maleButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(maleButton);

      expect(screen.getByText('患者設定確認')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('1')).toBeInTheDocument();
      expect(screen.getByText('新患(男性)')).toBeInTheDocument();
      expect(screen.getByText('新患')).toBeInTheDocument();
      
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('URL')).toBeInTheDocument();
      expect(screen.getByText('QRコード')).toBeInTheDocument();
      expect(screen.getByText('スタート')).toBeInTheDocument();
    });
  });

  describe('Back Confirmation To Start Page', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);
      const maleButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(maleButton);

      expect(screen.getByText('1')).toBeInTheDocument();
      expect(screen.getByText('新患(男性)')).toBeInTheDocument();
      expect(screen.getByText('新患')).toBeInTheDocument();

      const backButton = screen.getByText('戻る')
      fireEvent.click(backButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();


      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull();  

    });
  });

  describe('Confirmation To Url', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const post_promise = Promise.resolve({
        data: {
          status: 200,
          interview_key: "DEMOA"
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);
      (axios.post as any).mockResolvedValue(post_promise);

      render(<Index />);

      await act(() => promise );
      await act(() => post_promise );

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);
      const maleButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(maleButton);

      expect(screen.getByText('1')).toBeInTheDocument();
      expect(screen.getByText('新患(男性)')).toBeInTheDocument();
      expect(screen.getByText('新患')).toBeInTheDocument();

      const urlcopyButton = screen.getByText('URL')
      fireEvent.click(urlcopyButton);
      
      expect(await screen.findByText('URLのコピーまたはメッセージ送信（LINE）を行ってください')).toBeInTheDocument();

      expect(screen.queryByText('1人目の患者様')).toBeNull();
      expect(screen.queryByText('患者人数：1名')).toBeNull();

      expect(screen.getByText('URLのコピーまたはメッセージ送信（LINE）を行ってください')).toBeInTheDocument();
      
      expect(screen.getByText('コピー')).toBeInTheDocument();

      expect(screen.getByText('URLのコピーまたはメッセージ送信（LINE）を行ってください')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull();

    });
  });

  describe('Confirmation To Qrcode', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const post_promise = Promise.resolve({
        data: {
          status: 200,
          interview_key: "DEMOA"
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);
      (axios.post as any).mockResolvedValue(post_promise);

      render(<Index />);

      await act(() => promise );
      await act(() => post_promise );

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);
      const maleButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(maleButton);

      expect(screen.getByText('1')).toBeInTheDocument();
      expect(screen.getByText('新患(男性)')).toBeInTheDocument();
      expect(screen.getByText('新患')).toBeInTheDocument();

      const qrcodeButton = screen.getByText('QRコード')
      fireEvent.click(qrcodeButton);
      
      expect(await screen.findByText('QRコードを読み取ってください')).toBeInTheDocument();

      expect(screen.queryByText('1人目の患者様')).toBeNull();
      expect(screen.queryByText('患者人数：1名')).toBeNull();

      expect(screen.getByText('先確認QRコード表示画面')).toBeInTheDocument();
      expect(screen.getByText('QRコードを読み取ってください')).toBeInTheDocument();
      
      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull();

    });
  });

  describe('Confirmation To Start(Edit)', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise );

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);
      const maleButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(maleButton);

      expect(screen.getByText('1')).toBeInTheDocument();
      expect(screen.getByText('新患(男性)')).toBeInTheDocument();
      expect(screen.getByText('新患')).toBeInTheDocument();

      const editButton = screen.getByTestId("edit_button_1");
      fireEvent.click(editButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull();

    });
  });

  describe('Start(Edit) To Gender(Edit)', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise );

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);
      const maleButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(maleButton);
      const editButton = screen.getByTestId("edit_button_1");
      fireEvent.click(editButton);
      const editPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(editPatientButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('男性')).toBeInTheDocument();
      expect(screen.getByText('女性')).toBeInTheDocument();
      expect(screen.queryByText('再来男性')).toBeNull();
      expect(screen.queryByText('再来女性')).toBeNull();

      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();
    });
  });

  describe('Back Gender(Edit) To Start', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise );

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);
      const maleButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(maleButton);
      const editButton = screen.getByTestId("edit_button_1");
      fireEvent.click(editButton);
      const editPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(editPatientButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('男性')).toBeInTheDocument();
      expect(screen.getByText('女性')).toBeInTheDocument();
      expect(screen.queryByText('再来男性')).toBeNull();
      expect(screen.queryByText('再来女性')).toBeNull();

      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();

      const backButton = screen.getByText('戻る')
      fireEvent.click(backButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull();
    });
  });

  describe('Gender(Edit) To Confirmation', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise );

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);
      const maleButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(maleButton);
      const editButton = screen.getByTestId("edit_button_1");
      fireEvent.click(editButton);
      const editPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(editPatientButton);
      const femaleButton = screen.getByRole('button', {name: '女性'});
      fireEvent.click(femaleButton);

      expect(screen.getByText('患者設定確認')).toBeInTheDocument();
      expect(screen.getByText('患者人数：1名')).toBeInTheDocument();

      expect(screen.getByText('1')).toBeInTheDocument();
      expect(screen.getByText('新患(女性)')).toBeInTheDocument();
      expect(screen.getByText('新患')).toBeInTheDocument();
      
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('URL')).toBeInTheDocument();
      expect(screen.getByText('QRコード')).toBeInTheDocument();
      expect(screen.getByText('スタート')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();
    });
  }); 
}); 


// ２人パターン（新患＋再来）
describe('Index Patients', () => {
  describe('Change Patient Count', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      
      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();


      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull();


    });
  });

  describe('Start To PatientId Page', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('検索')).toBeInTheDocument();
      expect(screen.getByText('患者番号')).toBeInTheDocument();
      expect(screen.getByText('生年月日(年齢)')).toBeInTheDocument();
    });
  });

  describe('Back PatientId to Start Page', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index />);

      await act(() => promise);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);

      expect(screen.getByText('検索')).toBeInTheDocument();
      expect(screen.getByText('患者番号')).toBeInTheDocument();
      expect(screen.getByText('生年月日(年齢)')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();

      const backButton = screen.getByText('戻る')
      fireEvent.click(backButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();


      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull();

    });
  }); 

  describe('PatientId Search', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1", japanese_calendar_birthday: "平成02年01月01日"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1", japanese_calendar_birthday: "平成03年01月01日"}
          ]
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);

      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);

      expect(screen.getByText('検索したい内容を入力してください(氏名・カナ氏名・携帯電話番号・患者番号・生年月日)')).toBeInTheDocument();
      expect(screen.getByText('検索')).toBeInTheDocument();

      expect(screen.getByText('患者番号')).toBeInTheDocument();
      expect(screen.getByText('生年月日(年齢)')).toBeInTheDocument();
      expect(screen.getByText('携帯電話番号')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();

      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      //患者情報
      expect(screen.getByText('DEMO001')).toBeInTheDocument();
      expect(screen.getByText('テスト患者A')).toBeInTheDocument();
      // 年齢の処理は流用しているためここでは行わない。
      expect(screen.getByText('平成02年01月01日（-1）')).toBeInTheDocument();

      //患者情報
      expect(screen.getByText('DEMO002')).toBeInTheDocument();
      expect(screen.getByText('テスト患者B')).toBeInTheDocument();
      // 年齢の処理は流用しているためここでは行わない。
      expect(screen.getByText('平成03年01月01日（-1）')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();
    });
  }); 

  describe('PatientId checked style', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '女性', template_code: "female", display_web_name: "女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1", japanese_calendar_birthday: "平成02年01月01日"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1", japanese_calendar_birthday: "平成03年01月01日"}
          ]
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();
      expect(screen.getByText('DEMO001')).toBeInTheDocument();
      expect(screen.getByText('テスト患者A')).toBeInTheDocument();
      expect(screen.getByText('平成02年01月01日（-1）')).toBeInTheDocument();

      expect(screen.getByText('DEMO002')).toBeInTheDocument();
      expect(screen.getByText('テスト患者B')).toBeInTheDocument();
      expect(screen.getByText('平成03年01月01日（-1）')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);
      
      // スタイルが上手くとれないのでボタンのみの確認
      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeInTheDocument();

    });
  });

  describe('PatientId To Template', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);


      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const backButton = screen.getByText('次へ')
      fireEvent.click(backButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('再来男性')).toBeInTheDocument();
      expect(screen.getByText('再来女性')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();

    });
  }); 

  describe('Back Template To PatientId', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1", japanese_calendar_birthday: "平成02年01月01日"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1", japanese_calendar_birthday: "平成03年01月01日"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const nextButton = screen.getByText('次へ')
      fireEvent.click(nextButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('再来男性')).toBeInTheDocument();
      expect(screen.getByText('再来女性')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();

      const backButton = screen.getByText('戻る')
      fireEvent.click(backButton);

      // 検索のこってること
      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();
      expect(screen.getByText('DEMO001')).toBeInTheDocument();
      expect(screen.getByText('テスト患者A')).toBeInTheDocument();
      expect(screen.getByText('平成02年01月01日（-1）')).toBeInTheDocument();

      expect(screen.getByText('DEMO002')).toBeInTheDocument();
      expect(screen.getByText('テスト患者B')).toBeInTheDocument();
      expect(screen.getByText('平成03年01月01日（-1）')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeInTheDocument();
    });
  }); 

  describe('Template To Start', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const nextButton = screen.getByText('次へ')
      fireEvent.click(nextButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('再来男性')).toBeInTheDocument();
      expect(screen.getByText('再来女性')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();

      const templateButton = screen.getByText('再来男性')
      fireEvent.click(templateButton);

      expect(screen.getByText('2人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();


    });
  }); 
  
  describe('Start To Gender', () => {
    test('renders', async() => {
      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const nextButton = screen.getByText('次へ')
      fireEvent.click(nextButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      const templateButton = screen.getByText('再来男性')
      fireEvent.click(templateButton);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);

      expect(screen.getByText('2人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('男性')).toBeInTheDocument();
      expect(screen.getByText('女性')).toBeInTheDocument();
      expect(screen.queryByText('再来男性')).toBeNull();
      expect(screen.queryByText('再来女性')).toBeNull();

      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();
      
    });
  });

  describe('Confirmation', () => {
    test('renders', async() => {
      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const nextButton = screen.getByText('次へ')
      fireEvent.click(nextButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      const templateButton = screen.getByText('再来男性')
      fireEvent.click(templateButton);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);

      const newtemplateButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(newtemplateButton);

      expect(screen.getByText('患者設定確認')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('1')).toBeInTheDocument();
      expect(screen.getByText('再来(再来男性)')).toBeInTheDocument();
      expect(screen.getByText('テスト患者B')).toBeInTheDocument();

      expect(screen.getByText('2')).toBeInTheDocument();
      expect(screen.getByText('新患(男性)')).toBeInTheDocument();
      expect(screen.getByText('新患')).toBeInTheDocument();
      
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('URL')).toBeInTheDocument();
      expect(screen.getByText('QRコード')).toBeInTheDocument();
      expect(screen.getByText('スタート')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();

    });
  });  

  describe('Back Confirmation To Start', () => {
    test('renders', async() => {
      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const nextButton = screen.getByText('次へ')
      fireEvent.click(nextButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      const templateButton = screen.getByText('再来男性')
      fireEvent.click(templateButton);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);

      const newtemplateButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(newtemplateButton);

      const backButton = screen.getByText('戻る')
      fireEvent.click(backButton);

      expect(screen.getByText('2人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();
    });
  });  

  describe('Back Confirmation To Edit1', () => {
    test('renders', async() => {
      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const nextButton = screen.getByText('次へ')
      fireEvent.click(nextButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      const templateButton = screen.getByText('再来男性')
      fireEvent.click(templateButton);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);

      const newtemplateButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(newtemplateButton);

      const editButton = screen.getByTestId("edit_button_1");
      fireEvent.click(editButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull();      
    });
  });

  describe('Start(Edit) to Gender', () => {
    test('renders', async() => {
      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const nextButton = screen.getByText('次へ')
      fireEvent.click(nextButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      const templateButton = screen.getByText('再来男性')
      fireEvent.click(templateButton);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);

      const newtemplateButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(newtemplateButton);

      const editButton = screen.getByTestId("edit_button_1");
      fireEvent.click(editButton);

      const editPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(editPatientButton);   

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('男性')).toBeInTheDocument();
      expect(screen.getByText('女性')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();  
    });
  }); 

  describe('Back Gender To Start(Edit)', () => {
    test('renders', async() => {
      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const nextButton = screen.getByText('次へ')
      fireEvent.click(nextButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      const templateButton = screen.getByText('再来男性')
      fireEvent.click(templateButton);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);

      const newtemplateButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(newtemplateButton);

      const editButton = screen.getByTestId("edit_button_1");
      fireEvent.click(editButton);

      const editPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(editPatientButton);   
      
      const backButton = screen.getByText('戻る')
      fireEvent.click(backButton);

      expect(screen.getByText('1人目の患者様')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('新患')).toBeInTheDocument();
      expect(screen.getByText('再来')).toBeInTheDocument();

      expect(screen.queryByText('戻る')).toBeNull();
      expect(screen.queryByText('次へ')).toBeNull(); 

    });
  }); 

  describe('Edit1 Confirmation', () => {
    test('renders', async() => {
      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const nextButton = screen.getByText('次へ')
      fireEvent.click(nextButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      const templateButton = screen.getByText('再来男性')
      fireEvent.click(templateButton);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);

      const newtemplateButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(newtemplateButton);

      const editButton = screen.getByTestId("edit_button_1");
      fireEvent.click(editButton);

      const editPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(editPatientButton);   

      const edittemplateButton = screen.getByRole('button', {name: '女性'});
      fireEvent.click(edittemplateButton);

      expect(screen.getByText('患者設定確認')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('1')).toBeInTheDocument();
      expect(screen.getByText('新患(女性)')).toBeInTheDocument();
      expect(screen.getAllByText('新患')[0]).toBeInTheDocument();

      expect(screen.getByText('2')).toBeInTheDocument();
      expect(screen.getByText('新患(男性)')).toBeInTheDocument();
      expect(screen.getAllByText('新患')[1]).toBeInTheDocument();
      
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('URL')).toBeInTheDocument();
      expect(screen.getByText('QRコード')).toBeInTheDocument();
      expect(screen.getByText('スタート')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();
    });
  }); 

  describe('Back Confirmation Edit', () => {
    test('renders', async() => {
      const promise = Promise.resolve({
        data: {
          new_templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"}
          ],
          return_templates: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ],
          templates: [
            {id: 1, disable_flg: 0, template_kbn: 20, name: '男性', template_code: "male", display_web_name: "男性"}, 
            {id: 2, disable_flg: 0, template_kbn: 20, name: '女性', template_code: "female", display_web_name: "女性"},
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}, 
            {id: 4, disable_flg: 0, template_kbn: 30, name: '再来女性', template_code: "female", display_web_name: "再来女性"}
          ]
        }
      });

      const mock_patients = Promise.resolve({
        data: {
          m_patients: [
            {id: 1, consultation_ticket_no: 'DEMO001', name: 'テスト患者A', birthday: "1990/1/1"}, 
            {id: 2, consultation_ticket_no: 'DEMO002', name: 'テスト患者B', birthday: "1991/1/1"}
          ]
        }
      });

      const mock_template = Promise.resolve({
        data: {
          m_template: [
            {id: 3, disable_flg: 0, template_kbn: 30, name: '再来男性', template_code: "male", display_web_name: "再来男性"}
          ]
        }
      });

      const mock_line_linked = Promise.resolve({
        data: {
          line_linked: true
        }
      });
      
      (axios.get as any).mockImplementation((api) => {
        switch (api) {
          case '/api/internal/templates/get_interview_templates':
            return promise;
          case '/api/internal/patients/get_patients':
            return mock_patients;
          case '/api/internal/interview/get_revisited_patient_template':
            return mock_template;
          case '/api/internal/patients/check_line_linked':
            return mock_line_linked;
        }
      });

      render(<Index />);

      await act(() => promise);
      await act(() => mock_patients);
      await act(() => mock_template);

      const twoButton = screen.getByRole('button', {name: '2名'});
      fireEvent.click(twoButton);
      const returnPatientButton = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton);
      const serachButton = screen.getByText('検索')
      fireEvent.click(serachButton);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient = screen.getByText('DEMO002')
      fireEvent.click(checkPatient);

      const nextButton = screen.getByText('次へ')
      fireEvent.click(nextButton);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      const templateButton = screen.getByText('再来男性')
      fireEvent.click(templateButton);

      const newPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(newPatientButton);

      const newtemplateButton = screen.getByRole('button', {name: '男性'});
      fireEvent.click(newtemplateButton);

      const editButton = screen.getByTestId("edit_button_1");
      fireEvent.click(editButton);

      const editPatientButton = screen.getByRole('button', {name: '新患'});
      fireEvent.click(editPatientButton);   

      const edittemplateButton = screen.getByRole('button', {name: '女性'});
      fireEvent.click(edittemplateButton);

      const backButton = screen.getByText('戻る')
      fireEvent.click(backButton);

      const returnPatientButton2 = screen.getByRole('button', {name: '再来'});
      fireEvent.click(returnPatientButton2);
      const serachButton2 = screen.getByText('検索')
      fireEvent.click(serachButton2);

      expect(await screen.findByText('テスト患者A')).toBeInTheDocument();

      const checkPatient2 = screen.getByText('DEMO001')
      fireEvent.click(checkPatient2);

      const nextButton2 = screen.getByText('次へ')
      fireEvent.click(nextButton2);

      expect(await screen.findByText('再来男性')).toBeInTheDocument();

      const templateButton2 = screen.getByText('再来女性')
      fireEvent.click(templateButton2);

      expect(screen.getByText('患者設定確認')).toBeInTheDocument();
      expect(screen.getByText('患者人数：2名')).toBeInTheDocument();

      expect(screen.getByText('1')).toBeInTheDocument();
      expect(screen.getByText('新患(女性)')).toBeInTheDocument();
      expect(screen.getByText('新患')).toBeInTheDocument();

      expect(screen.getByText('2')).toBeInTheDocument();
      expect(screen.getByText('再来(再来女性)')).toBeInTheDocument();
      expect(screen.getByText('テスト患者A')).toBeInTheDocument();
      
      expect(screen.getByText('戻る')).toBeInTheDocument();
      expect(screen.getByText('URL')).toBeInTheDocument();
      expect(screen.getByText('QRコード')).toBeInTheDocument();
      expect(screen.getByText('スタート')).toBeInTheDocument();
      expect(screen.queryByText('次へ')).toBeNull();
    });
  }); 
 
}); 
  
 
  //   // screen.debug();
  // });
